import {api} from "./api";

export const zones = async () => {
    return await api.lget('zones')
}